import { FileType } from 'further-ui/utils';

const downloadXlxs = (file: string, fileName: string) => {
  const mediaType = `data:${FileType.ExcelAlt};base64,`;
  const aElement = document.createElement('a');
  aElement.setAttribute('download', `${fileName}.xlsx`);
  aElement.href = `${mediaType}${file}`;
  aElement.setAttribute('target', '_blank');
  aElement.click();
};

export default downloadXlxs;
